import useOrganization from '../../hooks/use-organization';
import OrganizationSettingsIndex from './organization';
import SettingsDetailR from './settings-page';

function SettingsIndex() {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? (
    <OrganizationSettingsIndex />
  ) : (
    <SettingsDetailR />
  );
}

export default SettingsIndex;
